import { generatePath } from 'react-router-dom'

import { Auth } from '@scouts/auth'
import { font, ButtonLink, Container, Line } from '@taxfix/scouts-ui'

import { PATH_COMPANY_OFFICER_EMAIL_REFERRAL_CONNECT } from '@/constants'

import { CompanyOfficerAuthContainer } from './CompanyOfficerAuthContainer'

export const CompanyOfficerAuthSignup = ({ onClickLogIn }: { onClickLogIn: VoidFunction }) => {
    const footer = (
        <Line size={font.small}>
            Already have an account? <ButtonLink onClick={onClickLogIn}>Log in here</ButtonLink>
        </Line>
    )

    const redirectPath = `${generatePath(PATH_COMPANY_OFFICER_EMAIL_REFERRAL_CONNECT)}?` // @TODO: Add query params (eg: companyKYCReferralId)

    return (
        <Container relative>
            <CompanyOfficerAuthContainer footer={footer}>
                <Auth.SignupForm.Compact redirectPath={redirectPath} />
            </CompanyOfficerAuthContainer>
        </Container>
    )
}
